import { DocumentTemplateType } from '../../../models/applications/application-documents';
import { Contract } from '../../../models/applications/contracts';
import { applicationDocumentsApi } from '../../../redux/api/applications/application-documents-api';
import { downloadFile } from '../../../utils/common';

export const useDownloadPaymentRequest = () => {
  const [generateDocument] =
    applicationDocumentsApi.useLazyGenerateDocumentQuery();

  return (contract: Contract) => {
    generateDocument({
      id: Number(contract.id),
      docType: DocumentTemplateType.PAYMENT_REQUEST,
    })
      ?.unwrap()
      .then(result => {
        downloadFile(
          new File(
            [result],
            'Направление на оплату договор_' + contract.number + '.docx'
          )
        );
      });
  };
};
